export default "__VITE_ASSET__fcbf06dc__"